module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "list-beers"
  }, [_c('div', {
    staticClass: "tabs is-centered sticky"
  }, [_c('ul', [_vm._m(0), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.sortBy === 'average'
    },
    on: {
      "click": function($event) {
        _vm.setSorting('average')
      }
    }
  }, [_c('a', [_vm._v("\n          Betyg\n          "), _c('i', {
    class: ['fa', _vm.sortValue ? 'fa-sort-asc' : 'fa-sort-desc']
  })])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.sortBy === 'name'
    },
    on: {
      "click": function($event) {
        _vm.setSorting('name')
      }
    }
  }, [_c('a', [_vm._v("\n          Öl\n          "), _c('i', {
    class: ['fa', _vm.sortValue ? 'fa-sort-asc' : 'fa-sort-desc']
  })])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.sortBy === 'brewery'
    },
    on: {
      "click": function($event) {
        _vm.setSorting('brewery')
      }
    }
  }, [_c('a', [_vm._v("\n          Bryggeri\n          "), _c('i', {
    class: ['fa', _vm.sortValue ? 'fa-sort-asc' : 'fa-sort-desc']
  })])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.sortBy === 'date'
    },
    on: {
      "click": function($event) {
        _vm.setSorting('date')
      }
    }
  }, [_c('a', [_vm._v("\n          Datum\n          "), _c('i', {
    class: ['fa', _vm.sortValue ? 'fa-sort-asc' : 'fa-sort-desc']
  })])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.toggleSearch()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]), _vm._v(" "), (_vm.showSearch) ? _c('div', {
    staticClass: "section"
  }, [_c('form', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "input is-medium",
    attrs: {
      "type": "text",
      "placeholder": "Har vi haft den förut? (dvs ölen)"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section columns is-multiline"
  }, _vm._l((_vm.orderBy(_vm.beerData)), function(beer) {
    return _c('div', {
      staticClass: "column is-one-third-tablet"
    }, [_c('article', {
      staticClass: "media"
    }, [_c('figure', {
      staticClass: "media-left"
    }, [_c('p', {
      staticClass: "image"
    }), _c('div', {
      staticClass: "average-score"
    }, [_vm._v(_vm._s(beer.average))]), _vm._v(" "), (beer.img) ? _c('img', {
      staticClass: "page-header__image",
      attrs: {
        "src": beer.img
      }
    }) : _c('img', {
      staticClass: "page-header__image",
      attrs: {
        "src": "static/default-beer.jpg"
      }
    }), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
      staticClass: "media-content"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('p'), _c('h2', {
      staticClass: "title"
    }, [_vm._v(_vm._s(beer.name))]), _vm._v(" "), _c('h4', {
      staticClass: "subtitle"
    }, [_vm._v(_vm._s(beer.brewery))]), _vm._v(" "), _c('small', [_c('table', {
      staticClass: "table is-narrow is-striped is-fullwidth"
    }, _vm._l((_vm.sortedRatings(beer.ratings)), function(user) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('td', {
        staticClass: "rating-info"
      }, [_c('span', {
        staticClass: "rating-info__bar",
        style: ({
          width: user.rating * 20 + 'px'
        })
      }), _vm._v(" "), _c('span', {
        staticClass: "rating-info__score"
      }, [_vm._v(_vm._s(user.rating))])])])
    })), _vm._v(" "), _c('p', [_vm._v("Provtillfälle: " + _vm._s(beer.date)), _c('br'), _vm._v("\n                Ölmästare: " + _vm._s(beer.boughtBy))])]), _vm._v(" "), _c('p')])])])])
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "is-hidden-mobile"
  }, [_c('strong', [_vm._v("Sortera:")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-00915f3a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00915f3a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ListBeers.vue
// module id = 147
// module chunks = 1